import { render, staticRenderFns } from "./StartNode.vue?vue&type=template&id=aee8cabe&scoped=true&"
import script from "./StartNode.vue?vue&type=script&lang=js&"
export * from "./StartNode.vue?vue&type=script&lang=js&"
import style0 from "./StartNode.vue?vue&type=style&index=0&id=aee8cabe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee8cabe",
  null
  
)

export default component.exports